import gsap from 'gsap';

import pageHeader from '../../components/page-header';

export const scrollBy = async (
    y,
    {
        duration = 0.4,
        onComplete = () => {},
        scroller = null,
    } = {}
) => {

    if (scroller === null) {
        scroller = window;
    }

    const timeline = gsap.timeline({
        paused: true,
    });

    timeline.to(
        scroller,
        {
            duration,
            scrollTo: {
                y: `+=${y}`,
            },
            onComplete,
        }
    );

    await timeline.play();
};

export const scrollTo = async (
    $element,
    {
        accountForHeader = true,
        offset = 0,
        duration = 0.4,
        onComplete = () => {},
        alignment = 'top',
        scroller = null,
    } = {}
) => {

    const timeline = gsap.timeline({
        paused: true,
    });

    if (scroller === null) {
        scroller = window;
    }

    const offsetForHeader = (
        accountForHeader
            ? pageHeader.minHeight()
            : 0
    );

    const offsetForAlignment = (() => {

        if (alignment === 'bottom') {
            return (
                $(scroller).outerHeight()
                - $element.outerHeight()
            );
        }

        if (alignment === 'center') {
            return (
                0.5 * (
                    $(scroller).outerHeight()
                    - $element.outerHeight()
                )
            );
        }

        return 0;
    })();

    const offsetY = (
        offsetForHeader
        + offsetForAlignment
        + offset
    );

    timeline.to(
        scroller,
        {
            duration,
            scrollTo: {
                y: $element,
                offsetY,
            },
            onComplete,
        }
    );

    await timeline.play();
};

